import './register_common_react';
import { reactOnCms } from 'common/js/react_on_cms';
import GridGallery from 'sealink/js/grid_gallery';
import CarouselGallery from 'sealink/react-components/carousel-gallery';
import CategoryCard from 'sealink/react-components/category-card';
import CategoryCardsCarousel from 'sealink/react-components/category-cards-carousel';
import ExperienceFilter from 'sealink/react-components/experience-filter';
import RelatedEntriesCarousel from 'sealink/react-components/related-entries-carousel';
import Experience from 'components/experience';
import Video from 'components/video';

reactOnCms.register({
  Experience,
  CategoryCard,
  ExperienceFilter,
  GridGallery,
  CarouselGallery,
  Video,
  RelatedEntriesCarousel,
  CategoryCardsCarousel,
});
